import { NgModule } from '@angular/core';
import { TopMenu } from './top-menu/top-menu';

import { Steps } from './steps/steps';
import { RouterModule } from '@angular/router';
import { Summary } from './summary/summary';
import { SharedAddressForm } from './shared-address-form/shared-address-form';
import { ProductCard } from './product-card/product-card';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { LanguageTranslation } from './language-translation/language-translation/language-translation';
import { LucideAngularModule, Globe } from 'lucide-angular';
import { FormsModule } from '@angular/forms';
import { SharedAcccountForm } from './shared-acccount-form/shared-acccount-form';
import { PhoneNumberField } from './phone-number-field/phone-number-field';
import { RecaptchaModule } from 'ng-recaptcha';
import { Status } from './status/status';
import { OfflinePopupComponent } from './offline-popup/offline-popup';
import { SharedCloudAccountForm } from './shared-cloud-account-form/shared-cloud-account-form';
import { SharedCloudAddressForm } from './shared-cloud-address-form/shared-cloud-address-form';
import { MaintenanceBanner } from './maintenance-banner/maintenance-banner';
import { ErrorBannerComponent } from './error-banner/error-banner';
import { PlainTextPopupComponent } from './plain-text-popup/plain-text-popup';

@NgModule({
  declarations: [
    TopMenu,
    Steps,
    Summary,
    SharedAcccountForm,
    SharedAddressForm,
    ProductCard,
    LanguageTranslation,
    Status,
    OfflinePopupComponent,
    SharedCloudAccountForm,
    SharedCloudAddressForm,
    MaintenanceBanner,
    ErrorBannerComponent,
    PlainTextPopupComponent
  ],
  imports: [
    RouterModule,
    ReactiveFormsModule,
    PhoneNumberField,
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    LucideAngularModule.pick({ Globe }),
    RecaptchaModule
  ],
  exports: [
    TopMenu,
    Steps,
    Summary,
    SharedAddressForm,
    SharedAcccountForm,
    PhoneNumberField,
    ProductCard,
    LanguageTranslation,
    RecaptchaModule,
    Status,
    OfflinePopupComponent,
    SharedCloudAccountForm,
    SharedCloudAddressForm,
    MaintenanceBanner,
    ErrorBannerComponent,
    PlainTextPopupComponent
  ]
})

export class LayoutModule { }
